import React, {useEffect, useState} from 'react';
import {useFormikContext} from 'formik';
import {useDispatch} from 'react-redux';
import $ from 'jquery';

import Modal from 'shared/components/modal';
import {errorMessage} from 'shared/actions/notifications';

const UnsavedChangesModal = () => {
  const dispatch = useDispatch();
  const {handleSubmit, isValid, dirty} = useFormikContext();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    $('a').off('click');
    $('a').click((e) => {
      if (dirty) {
        setShowModal(true);
        e.preventDefault();
      }
    });

    return () => {
      $('a').off('click');
    };
  }, [dirty]);

  const closeModal = () => setShowModal(false);

  return (
    <Modal show={showModal} onClose={closeModal}>
      <Modal.TextHeader onClose={closeModal}>Save Changes?</Modal.TextHeader>
      <Modal.Body>Are you sure you want to leave this page before saving your changes?</Modal.Body>
      <Modal.Footer
        primaryButton={{
          text: 'Save changes',
          onClick: () => {
            closeModal();
            handleSubmit();

            if (!isValid) {
              dispatch(errorMessage('Please resolve all errors to save your changes.'));
            }
          },
        }}
        secondaryButton={{
          text: 'Cancel',
          onClick: closeModal,
          rightAligned: true,
        }}
      />
    </Modal>
  );
};

export default UnsavedChangesModal;
